module.exports = __webpack_public_path__ + "static/media/rijksoverheid.359bd3d5.png";